import { useState } from 'react';
import Lightbox from 'yet-another-react-lightbox';
import 'yet-another-react-lightbox/styles.css';
import type { ImageMetadata } from '@/types/api';
import { api } from '@/lib/api';
import { formatFileSize } from '@/lib/utils';

interface ImageViewerProps {
  images: ImageMetadata[];
}

export function ImageViewer({ images }: ImageViewerProps) {
  const [currentIndex, setCurrentIndex] = useState<number>(-1);

  const slides = images.map((img) => ({
    src: api.getImageURL(img.id),
    title: img.variant || 'Original',
    description: formatFileSize(img.file_size),
  }));

  return (
    <>
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
        {images.map((image, index) => (
          <button
            key={image.id}
            onClick={() => setCurrentIndex(index)}
            className="group relative overflow-hidden rounded-lg border-2 border-stone-800 hover:border-gold-600 transition-colors bg-shadow-600 aspect-square"
          >
            <img
              src={api.getImageURL(image.id)}
              alt={image.variant || 'Map image'}
              className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-200"
              loading="lazy"
            />
            <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/80 to-transparent p-3">
              <p className="text-gold-200 text-sm font-medium">
                {image.variant || 'Original'}
              </p>
              <p className="text-stone-300 text-xs">
                {formatFileSize(image.file_size)}
              </p>
            </div>
          </button>
        ))}
      </div>

      <Lightbox
        open={currentIndex >= 0}
        close={() => setCurrentIndex(-1)}
        index={currentIndex}
        slides={slides}
      />
    </>
  );
}
